import React from 'react';
import ContactHome from './components/contact-home';
import MotionCard from './components/motion-card';
import CustomMargin from '../../components/custom-margin';
import MissionSection from './components/mission-section';
import FAQSection, { FAQ_ITEMS } from './components/faq-section';
import { LOCATION_ADD } from '../../components/constants';
import Testimonial from './components/testimonial';
import SEO, { lawOfficeSchema } from '../../components/seo';
import Reveal from '../../components/reveal';

const homeSchema = [
    lawOfficeSchema,
    {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: FAQ_ITEMS.map(({ question, answer }) => ({
            '@type': 'Question',
            name: question,
            acceptedAnswer: {
                '@type': 'Answer',
                text: answer,
            },
        })),
    },
];

export default function Home(){
    return(
        <div className="overflow-hidden bg-[#090909] pb-12 text-zinc-200">
            <SEO
                title="Quilaton Law Office | Lawyers in Cebu City"
                description="Quilaton Law Office is an independent, full-service law firm in Cebu City, Philippines, providing competent and ethical legal services."
                schema={homeSchema}
            />
            <CustomMargin className='px-5 py-10 lg:px-10'>
                <Reveal><ContactHome/></Reveal>
                <Reveal className="mb-8 border-b border-zinc-700/70 pb-6">
                    <h2 className='font-fontMontserrat text-4xl tracking-[0.08em] text-zinc-100 lg:text-5xl'>Law in Motion</h2>
                </Reveal>
                <Reveal delay={100}><MotionCard/></Reveal>
                <Reveal className='mt-14'>
                    <MissionSection/>
                </Reveal>
                <Reveal className='mt-14'>
                    <Testimonial />
                </Reveal>
                <Reveal><FAQSection/></Reveal>
            </CustomMargin>
           <Reveal className='px-5 pb-10 lg:px-10'>
                <CustomMargin className='flex lg:flex-col sm:flex-col'>
                    <div className='w-1/2 sm:w-full lg:w-full lg:mt-10'>
                        <div className="mb-6 border-b border-zinc-700/70 pb-5">
                            <div>
                                <h2 className='font-fontMontserrat text-3xl tracking-[0.12em] text-zinc-100 lg:text-5xl'>OUR OFFICE</h2>
                                <p className='mt-3 text-lg text-zinc-400'>{LOCATION_ADD}</p>
                            </div>
                        </div>
                        <div className="overflow-hidden rounded-2xl border border-zinc-700/80 bg-zinc-900 p-1 shadow-2xl shadow-black/50">
                            <iframe title='Google Map QLO' src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d387.45156976927985!2d123.8985644!3d10.3306627!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x33a9998fef8428b1%3A0x931c003a8a5118d4!2sQUILATON%20LAW%20OFFICE!5e0!3m2!1sen!2sph!4v1696929498263!5m2!1sen!2sph" width="100%" height="500" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                </CustomMargin>
           </Reveal>
        </div>
    );
}
